module.exports = __webpack_public_path__ + "assets/photo-profile.055b717c.svg";